<div class="content tw:bg-cyan-lightest">
  <h2>{{ "COMPONENTS.COOKIE_BANNER.TITLE" | translate }}</h2>
  @if (!open && cookieService.showSimpleBanner) {
    <header>
      <p>
        {{ "COMPONENTS.COOKIE_BANNER.MIN_VIEW.MESSAGE" | translate }}
        <br />
        {{ "COMPONENTS.COOKIE_BANNER.MIN_VIEW.SETTINGS" | translate }}
        <a vee-link class="cyan" (click)="openPreferences()">
          {{ "COMPONENTS.COOKIE_BANNER.MIN_VIEW.CLICK_HERE" | translate }}</a
        >!
      </p>

      <button vee-btn="filled" class="cyan" (click)="acceptAll()">
        {{ "COMPONENTS.COOKIE_BANNER.ACCEPT_ALL" | translate }}
      </button>
    </header>
  }
  @if (open || cookieService.changeOfRigthsNeeded) {
    <main>
      <label for="preferences"
        >{{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.PREFERENCES.NAME" | translate }}:
        <input type="checkbox" [(ngModel)]="preferences" id="preferences" />
        <div class="no-wrap">
          <span class="yes tw:text-primary">{{
            "COMPONENTS.YES" | translate
          }}</span>
          <span class="no tw:text-primary">{{
            "COMPONENTS.NO" | translate
          }}</span>
        </div>
      </label>
      <p>
        {{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.PREFERENCES.TEXT" | translate }}
      </p>
      @if (savePreferencesNeeded) {
        <p class="highlight tw:bg-white">
          {{
            "COMPONENTS.COOKIE_BANNER.MAX_VIEW.PREFERENCES.HIGHLIGHT"
              | translate
          }}
        </p>
      }
      <label for="dataconsent">
        {{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.FUNCTIONAL.NAME" | translate }}:
        <input type="checkbox" [(ngModel)]="dataconsent" id="dataconsent" />
        <div class="no-wrap">
          <span class="yes tw:text-primary">{{
            "COMPONENTS.YES" | translate
          }}</span>
          <span class="no tw:text-primary">{{
            "COMPONENTS.NO" | translate
          }}</span>
        </div>
      </label>
      <p>
        {{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.FUNCTIONAL.TEXT" | translate }}
      </p>
      <label for="google_analytics">
        {{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.GOOGLE_ADS.NAME" | translate }}:
        <input
          type="checkbox"
          [(ngModel)]="google_analytics"
          id="google_analytics"
        />
        <div class="no-wrap">
          <span class="yes tw:text-primary">{{
            "COMPONENTS.YES" | translate
          }}</span>
          <span class="no tw:text-primary">{{
            "COMPONENTS.NO" | translate
          }}</span>
        </div>
      </label>
      <p>
        {{ "COMPONENTS.COOKIE_BANNER.MAX_VIEW.GOOGLE_ADS.TEXT" | translate }}
      </p>
      <label for="data_protection">
        {{
          "COMPONENTS.COOKIE_BANNER.MAX_VIEW.DATA_PROTECTION.NAME" | translate
        }}:
        <input
          type="checkbox"
          [(ngModel)]="data_protection"
          id="data_protection"
        />
        <div class="no-wrap">
          <span class="yes tw:text-primary">{{
            "COMPONENTS.YES" | translate
          }}</span>
          <span class="no tw:text-primary">{{
            "COMPONENTS.NO" | translate
          }}</span>
        </div>
      </label>
      <p>
        {{
          "COMPONENTS.COOKIE_BANNER.MAX_VIEW.DATA_PROTECTION.TEXT" | translate
        }}
      </p>
      <nav>
        <button vee-btn="filled" class="red" (click)="accept()">
          {{ "COMPONENTS.COOKIE_BANNER.CONFIRM" | translate }}
        </button>
        <button vee-btn="filled" class="cyan" (click)="acceptAll()">
          {{ "COMPONENTS.COOKIE_BANNER.ACCEPT_ALL" | translate }}
        </button>
      </nav>
    </main>
  }
</div>
